module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebars"
  }, [_c('div', {
    staticClass: "sidebar right"
  }, [_c('button', {
    staticClass: "btn close-btn",
    attrs: {
      "data-action": "close",
      "data-side": "right",
      "name": "chat"
    },
    on: {
      "click": _vm.closeView
    }
  }, [_vm._m(0)]), _c('p', {
    staticClass: "chattitle"
  }, [_vm._v(_vm._s(_vm.inquiry_title) + " - " + _vm._s(_vm.client_name))]), _c('div', {
    attrs: {
      "id": "chat-frame"
    }
  }, [_c('div', {
    staticClass: "chat-inframe"
  }, [_vm._l((_vm.messages), function(message, index) {
    return _c('div', {
      staticClass: "chat-area"
    }, [_c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!message.user_id),
        expression: "!message.user_id"
      }],
      staticClass: "chat-talk"
    }, [_c('span', {
      staticClass: "talk-icon"
    }, [_c('img', {
      attrs: {
        "src": message.clientSrc
      }
    })]), _c('small', [_vm._v(" " + _vm._s(message.created_at))]), _c('pre', [_c('span', {
      staticClass: "talk-content"
    }, [_vm._v(" " + _vm._s(message.text))])]), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.file_name),
        expression: "message.file_name"
      }],
      staticClass: "myattachments"
    }, [_vm._v(" " + _vm._s(message.file_name))])]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.user_id),
        expression: "message.user_id"
      }],
      staticClass: "chat-talk client"
    }, [_vm._m(1, true), _c('small', [_vm._v(" " + _vm._s(message.created_at))]), _c('pre', [_c('span', {
      staticClass: "talk-content"
    }, [_vm._v(" " + _vm._s(message.text))])]), _c('a', {
      staticClass: "myattachments"
    }, [_vm._v(" " + _vm._s(message.file_name))])])])
  }), _c('div', {
    staticClass: "return-chat"
  }, [_c('router-link', {
    staticClass: "customsmallbutton btn btn-success",
    attrs: {
      "to": {
        name: 'chat',
        params: {
          id: this.inquiry_id
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("返信")])], 1)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-times-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "talk-icon company"
  }, [_c('i', {
    staticClass: "fa fa-building-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4255f18c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/message/MessageHistory.vue
// module id = 598
// module chunks = 1